import React, { useMemo, memo } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { stripInternalHost } from '../../lib/stripInternalHost';

export type Props = NavLinkProps;

export const Link: React.FC<Props> = memo(({ to, ...rest }) => {
  const resolvedTo = useMemo(() => (typeof to === 'string' ? stripInternalHost(to) : to), [to]);
  return <NavLink {...rest} to={resolvedTo} activeClassName="NavLink--active" />;
});
